"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const React = __importStar(require("react"));
const Radio_styled_1 = require("./Radio.styled");
const Radio = (props) => {
    var _a;
    const { name, value, label, onChange, checked, children } = props;
    const id = `${name}-${value}`;
    const inputRef = React.useRef(null);
    const handler = (e) => {
        var _a;
        e.preventDefault();
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        const newChecked = !checked;
        if (onChange) {
            onChange(newChecked, name, value);
        }
    };
    const className = `merlin-radio merlin-radio--${checked ? 'checked' : 'unchecked'} merlin-radio--${name} merlin-radio--${id}`;
    const styledProps = (_a = props.activeHighlightStyle) !== null && _a !== void 0 ? _a : {};
    return React.createElement(Radio_styled_1.StyledRadio, Object.assign({}, styledProps, { onClick: handler }),
        React.createElement("div", { className: `merlin-radio__wrapper` },
            React.createElement("label", { className: className, htmlFor: id },
                React.createElement("div", { className: "merlin-radio__container" },
                    React.createElement("input", { ref: inputRef, type: "radio", className: `merlin-radio__input ${className}`, value: value, id: id, name: name, onChange: handler, onKeyPress: (ev) => ev.key === 'Enter' && handler(ev), checked: checked }),
                    React.createElement("div", { className: "merlin-radio__button", onClick: handler }),
                    React.createElement("div", { "data-testid": `${id}-radio-label`, className: "merlin-radio__label", onClick: handler }, label || '')),
                React.createElement("div", { className: "merlin-radio__children" }, children))));
};
exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map